import * as Sentry from "@sentry/browser";
import i18next from 'i18next';
import HttpApi from 'i18next-http-backend';
import {getCountryInfo} from "../settings/location";

const urlParams = new URLSearchParams(window.location.search);
export const language = (urlParams.get("lang") || window.navigator.language);

function getLang_i18n() {
    if (language.startsWith("zh-")) {
        let splits = language.split("-");
        return `${splits[0]}-${splits[1]}`;
    }
    return language.split("-")[0];
}

i18next
    .use(HttpApi)
    .init({
        lng: getLang_i18n(),
        detection: {
            order: ['querystring', 'navigator'],
            lookupQuerystring: 'lang'
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        },
        fallbackLng: 'en'
    })
    .then(function (t) {
        // Find all elements with a `data-i18n` attribute
        const elements = document.querySelectorAll('[data-i18n]');

        // Loop over them and set their text content to the translated string
        elements.forEach(function (element) {
            const key = element.getAttribute('data-i18n');
            element.textContent = i18next.t(key);
        });
        // update the language code
        document.documentElement.lang = i18next.language;
    });


function toLocaleStringFallback(d, options) {
    try {
        return d.toLocaleString(language, options);
    } catch (e) {
        Sentry.captureException(e);
        return d.toLocaleString("en", options);
    }
}

const NarrowWeekdayLang = new Set(["he", "ar", "fa", "zh", "vi"]);
const RtlLanguages = new Set(["he", "ar", "fa"]);
const WeekStartSunday = new Set(["US", "CA", "PT", "JA", "TW", "TH", "HK", "IS", "IN", "PH", "BR", "MX", "KO"]);
const FahrenheitUnits = new Set(["US", "LR", "KY", "BZ"])

export function isRtlLanguage() {
    return RtlLanguages.has(language.split("-")[0]);
}

export const WEEKSTART = Object.freeze({
    MONDAY: Symbol("monday"),
    SUNDAY: Symbol("sunday")
});


Date.prototype.shortWeekday = function () {
    let options = {weekday: "short"};
    if (NarrowWeekdayLang.has(language.split("-")[0])){
        options = {weekday: "narrow"};
        return toLocaleStringFallback(this, options);
    } else {
        return toLocaleStringFallback(this, options).slice(0, 2);
    }
}


Date.prototype.isWeekEnd = function() {
    const country_code = getCountryInfo().countryCode;
    const FrSatWeekend = new Set([
        "DZ", // algeria
        "AF", // afghanistan
        "BH", // bahrain
        "BD", // bangladesh
        "IQ", // iraq
        "EG", // egypt
        "IL", // israel
        "JO", // jordan
        "KW", // kuwait
        "LY", // lybia
        "MV", // maldives
        "OM", // oman
        "QA",  // qatar
        "SY", // syria
        "SA", // saudi arabia
        "SD", // sudan
        "SS", // south sudan
        "YE"   // yemen
        ])
    if (FrSatWeekend.has(country_code)) {
        return [5,6].includes(this.getDay());
    }
    return [0,6].includes(this.getDay());
}

export function getDefaultCalendarDirection() {
    if (isRtlLanguage()){
        return "rtl";
    }
    return "ltr";
}

export function getDefaultTemperatureUnits() {
    const country_code = getCountryInfo().countryCode;
    if (FahrenheitUnits.has(country_code)) {
        return "F";
    }
    return "C";
}


export function getDefaultWeekStartDay() {
    const country_code = getCountryInfo().countryCode;
    if (WeekStartSunday.has(country_code)) {
        return "sunday";
    }
    return "monday";
}

// fetch prices
export function updateSubscriptionPrices() {
    let country_code = getCountryInfo().countryCode;
    fetch(`https://zima-backend.farawaytech.com/v1/subscription/prices?country_code=${country_code}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(function (response) {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error('Network response was not ok');
        }
    }).then(function (data) {
        let formatter = new Intl.NumberFormat(language, {
            style: 'currency',
            currency: data.currency,
            minimumFractionDigits: 0, // This option removes decimal places
        });

        document.querySelector('.monthly-price-text').textContent = formatter.format(data.monthlyPrice);
        document.querySelector('.yearly-price-text').textContent = formatter.format(data.yearlyPrice);
        document.querySelector('.obsolete-yearly-price-text').textContent = formatter.format(data.monthlyPrice*12);
        document.querySelector(".onetime-price-text").textContent = formatter.format(data.fixedPriceUnit);
    });
}
